import {Injectable, signal} from '@angular/core';
import {Platform} from '@angular/cdk/platform';

const DISMISSED_KEY = 'pwaInstallDismissed';

@Injectable({
    providedIn: 'root'
})
export class PwaInstallService {
    canShowBanner = signal(false);

    private deferredPrompt: any = null;

    constructor(private platform: Platform) {
        if (!this.platform.ANDROID) {
            return;
        }
        if (window.matchMedia('(display-mode: standalone)').matches) {
            return;
        }
        if (localStorage.getItem(DISMISSED_KEY) === 'true') {
            return;
        }

        window.addEventListener('beforeinstallprompt', (event: Event) => {
            event.preventDefault();
            this.deferredPrompt = event;
            this.canShowBanner.set(true);
        });
    }

    promptInstall() {
        if (!this.deferredPrompt) {
            return;
        }
        this.canShowBanner.set(false);
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.finally(() => {
            this.deferredPrompt = null;
        });
    }

    dismiss() {
        localStorage.setItem(DISMISSED_KEY, 'true');
        this.canShowBanner.set(false);
    }
}
